import useSWR from 'swr';
import { useAuthToken } from '@/contexts/auth/useAuthToken';
import { FixtureConfig } from '../types';
import {
  fetchFromMTService,
  SERVICE_ENDPOINT,
} from '../fetcher/monitoringToolService';
import { ApiError } from '../ApiError';
import { HTTP_STATUS_CODE } from '../constants';
export interface UseFixtureConfigParams {
  fixtureId?: string;
  collectionId?: string;
}
export const useFixtureConfig = ({
  fixtureId,
  collectionId,
}: UseFixtureConfigParams) => {
  const token = useAuthToken();
  const shouldFetch = !!token && !!collectionId && !!fixtureId;

  const {
    data: fixtureConfig,
    error,
    mutate,
  } = useSWR<FixtureConfig, ApiError>(
    shouldFetch
      ? {
          token,
          endpoint: SERVICE_ENDPOINT.Fixture(fixtureId, collectionId)
            .fixtureConfig.GET,
        }
      : null,
    fetchFromMTService,
    {
      onErrorRetry: (e, _, config, revalidate, { retryCount }) => {
        if (e.status === HTTP_STATUS_CODE.NOT_FOUND) return;
        if (e.status === HTTP_STATUS_CODE.UNAUTHORIZED) return;
        setTimeout(() => revalidate({ retryCount }), config.errorRetryInterval);
      },
      revalidateOnFocus: false,
    },
  );

  return {
    fixtureConfig,
    error,
    isLoading: shouldFetch && !fixtureConfig && !error,
    mutate,
  };
};
